import type { Maybe } from '@xing-com/crate-common-graphql-types';
import type {
  JobTeaserVisibleJobFragment,
  JobMatchingHighlightsV2Fragment,
} from '@xing-com/crate-jobs-graphql';
import type {
  NwtTrackingProps,
  OmitFromUnion,
} from '@xing-com/crate-jobs-tracking';
import type { SuperEllipseSize } from '@xing-com/super-ellipse';

import type { XingletInterface } from '../../jobs-xinglet';
import { JobsXingletWrapper } from '../../jobs-xinglet';

import { JobTeaserCardSkeleton } from './job-teaser-card-skeleton';

export type JobTeaserCardProps = {
  actions?: React.ReactElement;
  'aria-label'?: string;
  className?: string;
  'data-testid'?: string;
  hasTopButton?: boolean;
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  isNew?: boolean;
  job: JobTeaserVisibleJobFragment;
  matchingHighlights?: Maybe<JobMatchingHighlightsV2Fragment>;
  nwtTrackingOptionsBookmarkToggle?: OmitFromUnion<NwtTrackingProps, 'event'>;
  onAuxClick?: () => void;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onCompactedBookmark?: (isBookmarked: boolean) => void;
  onContextMenu?: () => void;
  profileImageSize?: SuperEllipseSize;
  profileImageSizeConfined?: SuperEllipseSize;
  target?: '_blank' | '_self';
  url?: string;
  variant?: 'default' | 'compact';
  hideApplyButton?: boolean;
  onBookmark?: () => void;
};

export type JobTeaserCardXinglet = XingletInterface<JobTeaserCardProps>;

export const JobTeaserCard = JobsXingletWrapper<JobTeaserCardProps>(
  '@xing-com/crate-jobs-components-job-teaser-card',
  <JobTeaserCardSkeleton />
);
